<template>
  <div class="list">
    <div class="row">
      <div
        class="card"
        v-for="farmland in filteredFarmlands"
        :key="farmland.id"
        @click="selectItem(farmland)"
      >
        <img :src="getImageUrl(farmland.photo_url)" class="card-image" />
        <h3>{{ farmland.name }}</h3>
        <p v-if="farmland.farm_type === 'COMMERCIAL'" class="farmland-code">
          {{ farmland.code }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import defaultFarmImg from "@/assets/img/finca/finca.jpg"; // Imagen por defecto
import { cacheGet, cacheSet } from "@/services/offlineService";

export default {
  name: "ListFarmlands",

  props: {
    farmType: {
      type: String,
      default: null, // 'COOPERATIVE' | 'COMMERCIAL' | null (sin filtro)
    },
    fruitType: {
      type: String,
      default: null, // 'FRESA' | 'ARANDANO' | 'ZARZAMORA' | 'FRAMBUESA' | null
    },
  },

  data() {
    return {
      farmlands: [],
    };
  },

  computed: {
    filteredFarmlands() {
      let source = this.farmType
        ? this.farmlands.filter((f) => f.farm_type === this.farmType)
        : this.farmlands;

      if (this.farmType === "COOPERATIVE" && this.fruitType) {
        source = source.filter((f) => f.fruit_type === this.fruitType);
      }

      return source.slice().sort(this.compareFarmlands);
    },
  },

  async mounted() {
    console.log("✅ Componente ListFarmlands montado");
    try {
      const url = this.$hostname + "/farmlands/";
      const cached = await cacheGet(url);
      if (cached) {
        this.farmlands = cached;
      } else {
        const response = await this.$http.get(url);
        console.log("🌱 Fincas cargadas:", response.data);
        this.farmlands = response.data;
        await cacheSet(url, response.data);
      }
    } catch (error) {
      console.error("❌ Error cargando fincas:", error);
    }
  },

  watch: {
    farmlands(newVal) {
      console.log("Farmlands actualizadas:", newVal);
    },
  },

  methods: {
    compareFarmlands(a, b) {
      const codeA = String((a && a.code) || "");
      const codeB = String((b && b.code) || "");
      const codeSort = codeA.localeCompare(codeB, "es", {
        numeric: true,
        sensitivity: "base",
      });
      if (codeSort !== 0) return codeSort;

      const nameA = String((a && a.name) || "");
      const nameB = String((b && b.name) || "");
      return nameA.localeCompare(nameB, "es", {
        numeric: true,
        sensitivity: "base",
      });
    },

    // Cuando se selecciona una finca
    selectItem(farmland) {
      this.$root.$emit("farmland", farmland);
    },

    // Si no hay foto, usar imagen por defecto
    getImageUrl(photoUrl) {
      if (!photoUrl) {
        return defaultFarmImg;
      }

      const normalizedUrl = String(photoUrl).trim();
      if (
        normalizedUrl.startsWith("data:") ||
        normalizedUrl.startsWith("blob:")
      ) {
        return normalizedUrl;
      }

      if (
        normalizedUrl.startsWith("http://") ||
        normalizedUrl.startsWith("https://")
      ) {
        try {
          const parsedUrl = new URL(normalizedUrl);
          if (
            ["localhost", "127.0.0.1", "0.0.0.0"].includes(
              parsedUrl.hostname,
            ) ||
            parsedUrl.hostname.startsWith("10.0.2.")
          ) {
            return `${this.$hostname}${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
          }
          if (parsedUrl.protocol === "http:") {
            parsedUrl.protocol = "https:";
          }
          return parsedUrl.toString();
        } catch {
          return normalizedUrl.replace(/^http:\/\//i, "https://");
        }
      }

      const path = normalizedUrl.startsWith("/")
        ? normalizedUrl
        : `/${normalizedUrl.replace(/^\/+/, "")}`;
      return `${this.$hostname}${path}`;
    },
  },
};
</script>

<style scoped>
.farmland-code {
  font-size: 0.8rem;
  color: #888;
  margin: 2px 0 0;
  text-align: center;
  font-style: italic;
}
</style>
